import type {
  PluginFooter,
  PluginFooterMode,
  PluginThemePresetName,
} from '@sportninja/common/features/account/apiAccess'

/** The Display group's on/off options. Labels are capitalized where shown. */
export const PLUGIN_DISPLAY_FLAGS: {
  name: string
  label: string
  hint?: string
}[] = [
  {
    name: 'display.hideHeader',
    label: 'Hide header',
    hint: 'Only tabs and content',
  },
  {
    name: 'display.todayGamesByDefault',
    label: "Today's games by default",
    hint: 'Schedule opens on Today',
  },
  { name: 'display.headerNavigation', label: 'Header navigation' },
]

/** The footer each choice stores; Branded (the plugin's own "Powered by" line) is the default (unset). */
export const PLUGIN_FOOTER_FOR_MODE: Record<
  PluginFooterMode,
  PluginFooter | null
> = {
  sportninja: null,
  hidden: 'hidden',
  custom: { text: '' },
}

export type PluginPreset = 'default' | PluginThemePresetName

export const PLUGIN_PRESET_OPTIONS: { label: string; value: PluginPreset }[] = [
  { label: 'Default', value: 'default' },
  { label: 'Ocean', value: 'ocean' },
  { label: 'Forest', value: 'forest' },
  { label: 'Crimson', value: 'crimson' },
  { label: 'Sunset', value: 'sunset' },
  { label: 'Royal', value: 'royal' },
]

/** The Spacing control's choices: the plugin's named steps plus a custom unit. */
export type PluginSpacingChoice = 'default' | 'compact' | 'custom'

/** The extra Spacing choice after the plugin's named steps. */
export const PLUGIN_CUSTOM_SPACING_OPTION: {
  label: string
  value: PluginSpacingChoice
} = { label: 'Custom', value: 'custom' }

/** Where a league picks a font family; the font fields' hint links here. */
export const GOOGLE_FONTS_URL = 'https://fonts.google.com/'

/** The plugin's values while unset, shown as placeholders. */
export const PLUGIN_BASE_FONT_SIZE = '16'
export const PLUGIN_BASE_MAX_WIDTH = '1200'
export const PLUGIN_BASE_SPACING_UNIT = '4'

/** Under each page type in Tabs: the one Embed starts on is the entry point. */
export const PLUGIN_TAB_SECTION_COPY = {
  entry: 'Your entry point: the page your plugin opens on',
  other: 'Used whenever your plugin shows this kind of page',
}
